export default {
  header: 'Please enter',
  processFlow: 'Process flow',
  box: 'Box',
  prio: 'Prio',
  testLoad: 'Test load',
};
